enum PortalSyncStatus {
    Unsent = 1,
    Pending = 2,
    Viewed = 3,
    Revoked = 4,
    Error = 5,
    Unsynchronized = 6,
    Locked = 7,
    Unknown = 0
}

export { PortalSyncStatus };
